import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

/**
 * Configuration Firebase du projet `vadom-d04d3`, partagé avec les
 * applications mobiles. Elle provient de l'app web « Vadom Web » déjà
 * enregistrée dans la console.
 *
 * Ces valeurs sont publiques par nature : elles sont embarquées dans le
 * bundle JavaScript de toute application Firebase côté client, exactement
 * comme `firebase_options.dart` les embarque dans le binaire mobile. Ce qui
 * protège les données, ce sont les règles de sécurité Firestore et la
 * vérification des jetons côté serveur — pas le secret de cette clé.
 */
const firebaseConfig = {
  apiKey: 'AIzaSyDErTpEEzerNFwZh8CXoZUjIRnj7SdVu4g',
  authDomain: 'vadom-d04d3.firebaseapp.com',
  projectId: 'vadom-d04d3',
  storageBucket: 'vadom-d04d3.firebasestorage.app',
  messagingSenderId: '1092259709263',
  appId: '1:1092259709263:web:485a8358b00da87a2f853a',
  measurementId: 'G-FS22RSLBZV'
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// L'appli et le site partagent la même base d'utilisateurs : on garde la
// langue des emails et SMS Firebase alignée sur celle de l'interface.
auth.languageCode = 'fr';

export default app;
